import React, { Component } from 'react'
import moment from 'moment'

import { envConstants } from '../../constants'

class EventsList extends Component {
  render () {
    const events = this.props.events
    return (
      <table className="hole-events">
        <thead>
          <tr>
            <th>Autosensor</th>
            <th>Max</th>
            <th>Gravità</th>
            <th>Velocità</th>
            <th>Imei</th>
            <th>Data</th>
          </tr>
        </thead>
        <tbody>
          {
            events.map((e, index) => {
              return (
                <tr key={index}>
                  <td>{e.autosensor}</td>
                  <td>{e.max}</td>
                  <td>{e.severity}</td>
                  <td>{e.speed}</td>
                  <td>{e.imei}</td>
                  <td>{moment.unix(e.detection_date).format(envConstants.momentFormat)}</td>
                </tr>
              )
            })
          }
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="6">
                Rilevazioni totali: {events.length}
            </td>
          </tr>
        </tfoot>
      </table>
    )
  }
}

export default EventsList
